<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <rect x="2.25" y="2.25" width="3.5" height="3.5" rx="1" ry="1" fill="var(--iconPrimary, #222)"/>
  <rect x="8.25" y="2.25" width="3.5" height="3.5" rx="1" ry="1" fill="var(--iconPrimary, #222)"/>
  <rect x="14.25" y="2.25" width="3.5" height="3.5" rx="1" ry="1" fill="var(--iconPrimary, #222)"/>
  <rect x="2.25" y="8.25" width="3.5" height="3.5" rx="1" ry="1" fill="var(--iconPrimary, #222)"/>
  <rect x="8.25" y="8.25" width="3.5" height="3.5" rx="1" ry="1" fill="var(--iconPrimary, #222)"/>
  <rect x="14.25" y="8.25" width="3.5" height="3.5" rx="1" ry="1" fill="var(--iconPrimary, #222)"/>
  <rect x="2.25" y="14.25" width="3.5" height="3.5" rx="1" ry="1" fill="var(--iconPrimary, #222)"/>
  <rect x="8.25" y="14.25" width="3.5" height="3.5" rx="1" ry="1" fill="var(--iconPrimary, #222)"/>
  <rect x="14.25" y="14.25" width="3.5" height="3.5" rx="1" ry="1" fill="var(--iconPrimary, #222)"/>

</svg>